// src/config/index.js

// 로컬 개발 환경 (npm start로 실행 시)
const local = {
  apiUrl: "https://ezylab-dev.ezylab.co.kr/", // 로컬 개발 서버 URL
};

// 개발 서버 환경 (빌드된 파일이 개발 서버의 Spring Boot static에서 서빙될 때)
const development = {
  apiUrl: "", // 상대경로 사용
};

// 운영 서버 환경 (빌드된 파일이 운영 서버의 Spring Boot static에서 서빙될 때)
const production = {
  apiUrl: "", // 상대경로 사용
};

// REACT_APP_ENV 환경 변수를 기반으로 환경 결정
const getConfig = () => {
  const env = process.env.REACT_APP_ENV;

  switch (env) {
    case "development":
      return development;
    case "production":
      return production;
    default:
      return local; // 기본값은 로컬 환경 (npm start)
  }
};

const config = getConfig();

// 업로드 파일 등 정적 에셋의 최종 URL 생성.
// 백엔드가 "/uploads/..." 형태의 경로를 반환하므로 환경별 apiUrl과 안전하게 결합한다.
// - 운영/개발 빌드: apiUrl="" → "/uploads/..." (동일 출처)
// - 로컬(npm start): apiUrl=dev 서버 → "https://.../uploads/..."
export const resolveAssetUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path; // 이미 절대 URL
  // 옛 절대 파일시스템 경로(/data/uploads/ezylab/board|portfolio|attachments/…)를
  // 공개 URL(/uploads/…)로 정규화 → DB 마이그레이션 없이 기존 이미지도 로드된다.
  // 예) /data/uploads/ezylab/portfolio/a.png, /data/uploads/ezylab_prod/board/b.png
  //  → /uploads/portfolio/a.png, /uploads/board/b.png
  let p = String(path).replace(/^.*\/uploads\/ezylab[^/]*\//, "/uploads/");
  const base = (config.apiUrl || "").replace(/\/+$/, "");
  const normalizedPath = p.startsWith("/") ? p : `/${p}`;
  return `${base}${normalizedPath}`;
};

export default config;
